import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { LandingMainPageEvent } from '../models/events/landingMainPageEvent.model';
import { LandingDetailPageEvent } from '../models/events/landingDetailPageEvent.model';
import { ReviewDocumentEvent } from '../models/events/reviewDocumentEvent.model';
import { DownloadPackEvent } from '../models/events/downloadPackEvent.model';
import { environment } from 'src/environments/environment';
import { agentAssignmentEvent } from '../models/events/agentAssignmentEvent.model';
import { BrokerService } from '../core/broker/broker.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  constructor(private _http: HttpClient, private _broker: BrokerService) {}

  private getCustomHeader(): HttpHeaders {
    return new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set(
        'Ocp-Apim-Subscription-Key',
        environment.apiManagement.subscriptionKey
      );
  }

  private postEvent(path: string, model: any): void {
    lastValueFrom(
      this._http.post(`${environment.apiManagement.address}${path}`, { ...model, BrokerID: this._broker.brokerId() }, {
        headers: this.getCustomHeader(),
      })
    ).catch((e) => console.error(e));
  }

  landingMaingPageEvent(model: LandingMainPageEvent) {
    this.postEvent('agentlogin', model);
  }

  landingDetailPageEvent(model: LandingDetailPageEvent) {
    this.postEvent('agentopen', model);
  }

  reviewDocumentEvent(model: ReviewDocumentEvent) {
    this.postEvent('documentstatus', model);
  }

  downloadPackEvent(model: DownloadPackEvent) {
    this.postEvent('agentdownload', model);
  }

  assignTaskEvent(model: agentAssignmentEvent) {
    this.postEvent('agentassign', model);
  }
}
